<template>
    <div class="rounded w-full px-2">
        <table class="text-left w-full border-collapse">
            <thead>
            <tr>
                <th colspan="9" class="text-center bg-teal text-white">
                    {{ name }}
                </th>
                <td class="text-center bg-teal text-white">
                    <i class="fa fa-fw text-left fa-btn fa-cog pointer" :id="tableConfigurationId"></i>
                    <b-popover :target="tableConfigurationId" placement="bottomleft">
                        <form>
                            <draggable
                                draggable=".item"
                                handle=".handle"
                                :list="columns"
                                @start="drag = true"
                                @end="drag = false"
                                >
                                <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                                    <div
                                        class="item d-flex align-items-center"
                                        v-for="(column, index) in columns"
                                        :key="column.name">
                                        <i class="fa fa-align-justify handle pr-1"></i>
                                        <b-form-checkbox
                                            v-model="column.checked"
                                            >
                                            {{ column.name }}
                                        </b-form-checkbox>
                                    </div>
                                </transition-group>
                            </draggable>
                        </form>
                    </b-popover>
                    <i class="fa fa-fw text-left fa-btn fa-external-link pointer" v-on:click="exportToExcel"></i>
                </td>
            </tr>
            <tr>
                <th class="bg-grey-lightest border-b border-grey-light"></th>
                <th
                    v-for="(column, index) in availableColumns"
                    class="py-3 bg-grey-lightest border-b border-grey-light"
                    :class="column.customClass"
                    :key="column.name">
                    <button class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                        :class="currentOrder.property === column.order ? 'text-teal' : ''"
                        @click="order(column.order)">
                        {{ column.name }}
                        <i class="fa fa-xs fa-chevron-down ml-2"
                            v-if="currentOrder.property === column.order && currentOrder.direction === 'desc'"></i>
                        <i class="fa fa-xs fa-chevron-up ml-2"
                            v-if="currentOrder.property === column.order && currentOrder.direction === 'asc'"></i>
                    </button>
                </th>
            </tr>
            </thead>
            <tbody>
                <tr v-for="(project, index) in projects" :key="index"
                    class="hover:bg-grey-lighter cursor-pointer"
                    @click="goToProject(project)">
                    <td :class="Number(project.age) < 0 ? 'bg-green' : 'bg-red'" class="pl-2 py-2 border-b"></td>
                    <td
                        class="py-2 border-b border-grey-light text-grey-darkest text-xs"
                        v-for="(column, index) in availableColumns"
                        :class="[column.customClass, {'bg-qualified':project.pre_qualified && column.property_name === 'project_name'}]"
                        :key="column.name">
                        <template v-if="column.property_name === 'contact_cell'">
                            <formatted-phone
                                v-if="project[column.property_name] > 0"
                                :masks="masks"
                                :phone="project[column.property_name]"/>
                        </template>
                        <template v-else>
                            {{
                                column.property_name === 'age'
                                ? (project.age < 0 ? '-' : project.age)
                                : project[column.property_name]
                            }}
                        </template>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import FormattedPhone from '../shared/formatted-phone';

export default {
    props: ['name' , 'projects', 'current-order', 'state', 'masks', 'filter', 'user', 'fixedDateRangeIdentifier'],
    data() {
        return {
            drag: false,
            columns: this.state[this.name],
        };
    },
    methods: {
        goToProject(project) {
            if (project.id === '-') {
                window.location = route('company.show', {company: project.company_id});
            } else {
                window.location = route('project.edit', {project: project.id, dashboard: 1});
            }
        },

        order(property) {
            this.$emit('order', property);
        },

        saveState() {
            let newState = this.state;
            newState[this.name] = this.columns;
            axios.put(route('api.dashboard.state'), { state: newState })
                .then(response => {
                });
        },

        exportToExcel() {
            let newwindow = window.open(route('dashboard.excel', {
                "start-date": this.filter.start,
                "end-date": this.filter.end,
                user: this.user.id,
                "fixed-date-ranger-identifier": this.fixedDateRangeIdentifier,
                "behavior-name": this.name,
                "columns": this.availableColumns.map(column => ({
                    name: column.name,
                    property_name: column.property_name
                })),
            }), this.name, 'location=0,width=860,height=740,toolbar=0,menubar=0,location=0');
            if (window.focus) {newwindow.focus()}
        }
    },
    components: {
        draggable,
    },
    computed: {
        availableColumns() {
            return this.columns.filter(column => column.checked);
        },
        tableConfigurationId() {
            return 'table-configuration-' + this.name;
        }
    },
    watch: {
        columns: {
            handler: function (val, oldVal) {
                this.saveState();
            },
            deep: true
        }
    },
    created() {
        this.saveState();
        console.log("editable table");
    }
}
</script>

<style lang="scss">
    .bg-qualified{
        background-color: #00ff8f;
    }
    tr td:nth-child(2), tr th:nth-child(2) {
        padding-left: .5rem;
    }
    .pointer {
        cursor: pointer;
    }
    .flip-list-move {
        transition: transform 0.5s;
    }
    .no-move {
        transition: transform 0s;
    }
</style>
